import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Drawer from '../Drawer';
import DrawerControl from '../DrawerControl';
import WithClickOutside from '../WithClickOutside';
import * as styles from './SlidingDrawer.scss';

/**
 * Reusable Sliding Drawer Component
 * @function SlidingDrawer
 * @param {Object} props
 * @return {ReactElement}
 * @example ./SlidingDrawer.md
 */
const SlidingDrawer = (props) => {
  const {
    children,
    className,
    controlClassName,
    controlStyle,
    drawerClassName,
    drawerStyle,
    onClick,
    onClickOutside,
    open,
    style,
  } = props;

  return (
    <WithClickOutside handleClickOutside={onClickOutside}>
      <div className={classNames(styles.slidingDrawer, className)} style={style}>
        <div className={styles.drawerContent}>
          <DrawerControl
            className={controlClassName}
            onClick={onClick}
            open={open}
            style={controlStyle} />
          <Drawer
            className={classNames(
              drawerClassName,
              { [styles.drawerClosed]: !open },
              { [styles.drawerOpen]: open },
            )}
            open={open}
            style={drawerStyle}
          >
            {children}
          </Drawer>
        </div>
      </div>
    </WithClickOutside>
  );
};

SlidingDrawer.propTypes = {
  onClick: PropTypes.func.isRequired,
  onClickOutside: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
  controlClassName: PropTypes.string,
  controlStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  drawerClassName: PropTypes.string,
  drawerStyle: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default SlidingDrawer;
